import isArray from 'lodash/isArray';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString'; // a helper method to convert a node to a
// succinct, pretty, human-readable string
// for error and messages

export default function stringifyNode(node) {
  if (!node) return "".concat(node);
  if (isString(node)) return node;
  if (isNumber(node)) return "".concat(node);
  if (isArray(node)) return "[".concat(node, "]");
  var type = node.type,
      version = node.version;
  return "{ type: '".concat(type, "', version: '").concat(version, "' }");
}